import React from "react";
import { Container } from "./styled";

const Story = () => {
  return (
    <Container>
      <div>
        <h2>Nuestra historia</h2>
        <p>
          Somos amantes del deporte y la tecnología. Comenzamos en busca de
          mejorar las practicas deportivas y buscamos ayudar a los equipos a
          mejorar y maximizar su rendimiento.
        </p>
      </div>
    </Container>
  );
};

export default Story;
